import { createContext } from 'react';

export const AuthContextState = createContext<any>({});
